<template>
  <b-row>
    <b-col cols="12" v-show="displayRegisterForm">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }" slim>
        <b-form @submit.prevent="handleSubmit(registerAthlete)">

          <b-row>
            <!-- Feld: Lizenznummer -->
            <b-col sm="6">
              <ValidationProvider
                :name="$t('event_anmeldung.label_swiss_athletics_lizenznummer')"
                rules=""
                v-slot="validationContext"
              >
                <b-form-group
                  id="fieldset-satMemberNumber"
                  :label="$t('event_anmeldung.label_swiss_athletics_lizenznummer')"
                  label-for="input-satMemberNumber"
                >
                  <b-form-input
                    id="input-satMemberNumber"
                    v-model="form.satMemberNumber"
                    :state="getValidationState(validationContext)"
                    aria-describedby="feedback-satMemberNumber"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback id="feedback-satMemberNumber">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row>
            <!-- Feld: Vorname -->
            <b-col sm="6">
              <ValidationProvider
                :name="$t('event_anmeldung.label_vorname')"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group
                  id="fieldset-firstName"
                  :label="$t('event_anmeldung.label_vorname') + ' *'"
                  label-for="input-firstName"
                >
                  <b-form-input
                    id="input-firstName"
                    v-model="form.firstName"
                    :state="getValidationState(validationContext)"
                    aria-describedby="feedback-firstName"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback id="feedback-firstName">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            
            <!-- Feld: Nachname -->
            <b-col sm="6">
              <ValidationProvider
                :name="$t('event_anmeldung.label_nachname')"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group
                  id="fieldset-lastName"
                  :label="$t('event_anmeldung.label_nachname') + ' *'"
                  label-for="input-lastName"
                >
                  <b-form-input
                    id="input-lastName"
                    v-model="form.lastName"
                    :state="getValidationState(validationContext)"
                    aria-describedby="feedback-lastName"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback id="feedback-lastName">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row>
            <!-- Feld: Jahrgang -->
            <b-col sm="6">
              <ValidationProvider
                :name="$t('event_anmeldung.event_anmeldung')"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group
                  id="fieldset-ageGroup"
                  :label="$t('event_anmeldung.label_jahrgang') + ' *'"
                  label-for="input-ageGroup"
                >
                  <b-form-select
                    id="input-ageGroup"
                    v-model="form.ageGroup"
                    :options="selectFields.ageGroup"
                    :state="getValidationState(validationContext)"
                    aria-describedby="feedback-ageGroup"
                    size="sm"
                  ></b-form-select>
                  <b-form-invalid-feedback id="feedback-ageGroup">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            
            <!-- Feld: Geschlecht -->
            <b-col sm="6">
              <ValidationProvider
                :name="$t('event_anmeldung.label_geschlecht')"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group
                  id="fieldset-sex"
                  :label="$t('event_anmeldung.label_geschlecht') + ' *'"
                  label-for="input-sex"
                >
                  <b-form-select
                    id="input-sex"
                    v-model="form.sex"
                    :options="selectFields.sex"
                    :state="getValidationState(validationContext)"
                    aria-describedby="feedback-sex"
                    size="sm"
                  ></b-form-select>
                  <b-form-invalid-feedback id="feedback-sex">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row>
            <!-- Feld: Adresse -->
            <b-col>
              <ValidationProvider
                :name="$t('event_anmeldung.label_adresse')"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group
                  id="fieldset-addressLine1"
                  :label="$t('event_anmeldung.label_adresse') + ' *'"
                  label-for="input-addressLine1"
                >
                  <b-form-input
                    id="input-addressLine1"
                    v-model="form.addressLine1"
                    :state="getValidationState(validationContext)"
                    aria-describedby="feedback-addressLine1"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback id="feedback-addressLine1">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
          
          <b-row>
            <!-- Feld: PLZ -->
            <b-col sm="4" md="3">
              <ValidationProvider
                :name="$t('event_anmeldung.label_plz')"
                rules="required|numeric|max:4"
                v-slot="validationContext"
              >
                <b-form-group
                  id="fieldset-zip"
                  :label="$t('event_anmeldung.label_plz') + ' *'"
                  label-for="input-zip"
                >
                  <b-form-input
                    id="input-zip"
                    v-model="form.zip"
                    :state="getValidationState(validationContext)"
                    aria-describedby="feedback-zip"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback id="feedback-zip">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            
            <!-- Feld: Ort -->
            <b-col sm="8" md="9">
              <ValidationProvider
                :name="$t('event_anmeldung.label_ort')"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group
                  id="fieldset-city"
                  :label="$t('event_anmeldung.label_ort') + ' *'"
                  label-for="input-city"
                >
                  <b-form-input
                    id="input-city"
                    v-model="form.city"
                    :state="getValidationState(validationContext)"
                    aria-describedby="feedback-city"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback id="feedback-city">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row>
            <!-- Feld: Kanton -->
            <b-col>
              <ValidationProvider
                :name="$t('event_anmeldung.label_kanton')"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group
                  id="fieldset-canton"
                  :label="$t('event_anmeldung.label_kanton') + ' *'"
                  label-for="input-canton"
                >
                  <b-form-select
                    id="input-canton"
                    v-model="form.canton"
                    :options="selectFields.canton"
                    :state="getValidationState(validationContext)"
                    aria-describedby="feedback-canton"
                    size="sm"
                  ></b-form-select>
                  <b-form-invalid-feedback id="feedback-canton">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row>
            <!-- Feld: Verein -->
            <b-col>
              <ValidationProvider
                :name="$t('event_anmeldung.label_verein_schule')"
                rules=""
                v-slot="validationContext"
              >
                <b-form-group
                  id="fieldset-club"
                  :label="$t('event_anmeldung.label_verein_schule')"
                  label-for="input-club"
                >
                <vue-typeahead-bootstrap v-model="form.club" id="input-club" size="sm" :showAllResults="true" :ieCloseFix="false" :data="vereine" @input="clubSelected" >
                    </vue-typeahead-bootstrap>
                  <b-form-invalid-feedback id="feedback-club">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col sm="6">
            <!-- Feld: E-Mail -->
              <ValidationProvider
                :name="$t('event_anmeldung.label_email')"
                rules="required|email"
                v-slot="validationContext"
              >
                <b-form-group
                  id="fieldset-email"
                  :label="$t('event_anmeldung.label_email') + ' *'"
                  label-for="input-email"
                >
                  <b-form-input
                    id="input-email"
                    v-model="form.email"
                    :state="getValidationState(validationContext)"
                    aria-describedby="feedback-email"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback id="feedback-email">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col sm="6">
            <!-- Feld: E-Mail Typ -->
              <ValidationProvider
                :name="$t('event_anmeldung.label_email_type')"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group
                  id="fieldset-emailType"
                  :label="$t('event_anmeldung.label_email_type') + ' *'"
                  label-for="input-emailType"
                >
                  <b-form-select
                    id="input-emailType"
                    v-model="form.emailType"
                    :options="selectFields.emailType"
                    :state="getValidationState(validationContext)"
                    aria-describedby="feedback-emailType"
                    size="sm"
                  ></b-form-select>
                  <b-form-invalid-feedback id="feedback-emailType">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
          
          <b-row>
            <!-- Feld: Sprache -->
            <b-col sm="6">
              <ValidationProvider
                :name="$t('event_anmeldung.label_sprache')"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group
                  id="fieldset-language"
                  :label="$t('event_anmeldung.label_sprache') + ' *'"
                  label-for="input-language"
                >
                  <b-form-select
                    id="input-language"
                    v-model="form.language"
                    :options="selectFields.language"
                    :state="getValidationState(validationContext)"
                    aria-describedby="feedback-language"
                    size="sm"
                    class="mt-1"
                  ></b-form-select>
                  <b-form-invalid-feedback id="feedback-language">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <!-- Feld: Einverständniss der Teilnahmebedingungen -->
              <b-form-checkbox
                id="input-agbAccepted"
                v-model="form.agbAccepted"
                :value="true"
                :unchecked-value="false"
                class="mb-3"
              >
                <span v-html="$t('event_anmeldung.text_terms')"></span>
                <small v-if="customError.agbAccepted.display" class="d-block text-danger">{{ customError.agbAccepted.message }}</small>
              </b-form-checkbox>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col>
              <!-- Feld: Informationen über Partnerangebote erlauben -->
              <b-form-checkbox
                id="input-receivePartnerOffers"
                v-model="form.receivePartnerOffers"
                :value="true"
                :unchecked-value="false"
                class="mb-3"
              >
              <span v-html="$t('event_anmeldung.text_partner_angebote')"></span>
              </b-form-checkbox>
            </b-col>
          </b-row>
          
          <b-row v-if="formFeedback.display">
            <b-col>
              <b-alert :variant="formFeedback.type" show>
                {{ formFeedback.message }}
              </b-alert>
            </b-col>
          </b-row>
          
          <b-row align-h="between">
            <b-col cols="6" xl="2" lg="3" md="4" class="ml-auto">
              <b-button type="submit" block>
                {{ $t('event_anmeldung.label_anmelden') }}
              </b-button>
            </b-col>
          </b-row>

        </b-form>
      </ValidationObserver>
    </b-col>
    <b-col v-if="feedback.display">
      <b-row>
        <b-col :class="`text-center text-${feedback.type}`">
          <h1>{{ feedback.title }}</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center">
          <p>{{ feedback.message }}</p>
        </b-col>
      </b-row>
      <b-row v-if="feedback.displayBtns">
        <b-col class="text-center mb-3 mx-auto" style="max-width: 300px">
          <b-button @click="$emit('reset')" variant="primary" block>
            {{ $t('event_anmeldung.label_weiteres_kind_anmelden') }}
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="feedback.displayBtns">
        <b-col class="text-center mx-auto" style="max-width: 300px">
          <b-button :to="`/${$i18n.locale}/veranstaltungen`" variant="light" block>
            {{ $t('event_anmeldung.label_zurück_zur_veranstaltungssuche') }}
          </b-button>
        </b-col>
      </b-row>
    </b-col>
    <div
      v-if="displayPageLoader"
      id="pageLoader"
      class="d-flex justify-content-center align-items-center"
    >
      <b-spinner label="Loading..."></b-spinner>
    </div>
  </b-row>
</template>

<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

export default {
  components: {
    VueTypeaheadBootstrap
  },
  data() {
    return {
      user: null,
      vereine: '',
      //TODO: move to seperate File 
      vereinListe: ['TV Stein (AG)','TV Zofingen LA','SATUS Rothrist LA','BTV Aarau Athletics','TV Buchs AG','LV Fricktal','LAR TV Windisch','Laufsportgruppe Brugg','Vom Stein Baden','TV Wohlen AG','LA Villmergen','STV Beinwil/Freiamt','STV Auw','SATUS Gränichen','STV Gränichen LA','STV Mühlau','LV Wettingen-Baden','LA Mutschellen','Lauf-Team Lenzburg','FSG La Neuveville','CA Courtelary','CA Moutier','GG Bern','STB Leichtathletik','TV Länggasse Bern','LAG TV Zollikofen','TV Bolligen','TV Ostermundigen','TV Schwarzenburg','TV Oberwangen','TSV Frauenkappelen','LAC Wohlen','TV Lyss','TV Fraubrunnen','TV Herzogenbuchsee','LA Rüegsauschachen','LC Kirchberg','STV Sumiswald','TV Grosshöchstetten','TV Konolfingen Athletics','SK Langnau','LV Thun','TV Spiez','LC Scharnachtal','TV Saanen-Gstaad','TV Unterseen','TV Meiringen','LV Langenthal','LV Huttwil','TV Attiswil','Satus Biel-Bienne','TV Oberdiessbach','Fun and Run Thun','TV Aarberg Leichtathletik','Gerbersport','Biel/Bienne Athletics','TV Lützelflüh Athletics','FSG St-Imier','TVM Buchsi-Athletics','TSV Vechigen','FSG Féminine Tavannes','TIP-TOP Swiss Polysport','Turn- und Sportverein Wangen an der Aare','Laufteam Emmental','Turnverein Kehrsatz','LAS Old Boys Basel','LC Basel','LAR Binningen','Sportclub Biel-Benken','LC Therwil','TV Riehen','TV Muttenz athletics','TV Arlesheim','SC Liestal','LG Oberbaselbiet / BTV Sissach','Blind-Jogging','Basel Running Club Athletics','LV FrenkeFortuna','Verein Kinder-Camps','FSG Estavayer','SA Bulle','CS Marsens','CS Neirivue','CARC Romont','CA Fribourg','Athletic Team Rechthalten','TSV Heitenried','Sportverein Alterswil','CA Marly','CS Le Mouret','CA Gibloux Farvagny','CA Belfaux','CA Rosé','TV Bösingen','TSV Wünnewil','TSV Düdingen','TSV Gurmels','AC Murten','TV Plaffeien','Athletica Veveyse','TSV St. Antoni','Cottens Athlètes','Athlétisme Viseu-Genève','CA Genève','CHP Genève','Stade Genève','FSG Meyrin','C.H. Châtelaine','SATUS Athl. Genève','FSG Bernex-Confignon','FSG Versoix','Versoix Athlétisme','Perform-CBS','Athletic Club 3-Chêne','InVia Run','Florimont-Athletic Club','LAV Glarus','BTV Chur Leichtathletik','AJ TV Landquart','TV Thusis','TV Tamins','LC Luzern','TV Reussbühl LA','LC Emmenstrand','TSV Rothenburg athletics','TV Inwil','LR Ebikon','Leichtathletik-Vereinigung Horw','TV Sarnen LA','STV Malters','TV Wolhusen','STV Willisau','LR Gettnau','STV Altbüron','TSV Oberkirch','TV Sursee','STV Beromünster','STV Roggliswil','STV Ballwil','AUDACIA Hochdorf Leichtathletik','LAR STV Hitzkirch','LK Zug','Hochwacht Zug','TV Cham 1884','STV Oberägeri','TSV 2001 Rotkreuz','LA Nidwalden','LC Altdorf','Leichtathletik Kerns','STV Sempach','TV Grosswangen','TV Bürglen','Team FitSport.ch','Laufgruppe Cham Track','LR Nottwil','LGV 2015 Zug','Leichtathletik Alpnach','Athletikzentrum Sarnen-Unterwalden','ESV Eschenbach','STV Unterägeri','GS Franches-Montagnes','Delémont Athlétisme','FSG Courroux','Fémina Vicques','FSG Bassecourt','FSG Alle','CA Fontenais','FSG Courgenay','CA des Franches-Montagnes','CEP Cortaillod','FSG Bevaix','FSG Corcelles-Cormondrèche','FSG Couvet','FSG Geneveys et Coffrane','SEP Olympic La Chaux-de-Fonds','FSG Le Locle','FSG Cernier','LAG Gossau','LC Rapperswil-Jona','STV Eschenbach SG','TV Mels','LA Speicher','LR TV Appenzell','TV Teufen','TV Herisau','TV Lütisburg','LGB Bodensee','TV Thal','STV Au SG','TV Widnau','Athleticteam KTV Altstätten','STV Balgach','KTV Oberriet','STV Oberriet-Eichenwies','STV Gams','LC Vaduz','TV Eschen-Mauren','LC Schaan','TV Schaan / Leichtathletik','Turnverein Triesen','KTV Wil LA','KTV Bütschwil','LC Brühl Leichtathletik','LGB Benken','TV St. Peterzell','STV Grabs','LA Sennwald','STV Kriessern','TSV Engelburg','STV St. Margrethen','TSV Fortitudo Gossau','TV St. Gallen-Ost','STV Ganterschwil','TV Schänis','TV Azmoos','SVD athletics','STV Marbach SG','TSV Hinterforst','Turnverein Bad Ragaz','LC Schaffhausen','PLUSPORT Behindertensport Schweiz','TV Grenchen','Biberist aktiv! Leichtathletik','STV Bettlach','TV Selzach','Laufental Thierstein Athletics','TV Biezwil','LA-Riege TV Olten','STV Gunzgen','LA TV Wolfwil','LZ Lostorf','TSV Kestenholz','STV Welschenrohr','TV Gretzenbach','TSV Mümliswil-Ramiswil','STV Oensingen','Leichtathletikclub Oensingen','STV Hägendorf','STV Küssnacht','TSV Steinen','TV Ibach','TV Brunnen','STV Gersau','KTV Freienbach','STV Pfäffikon-Freienbach','STV Wollerau-Bäch','ETV Schindellegi','STV Einsiedeln','KTV Altendorf','Turnverein Siebnen','TSV Galgenen','STV Wangen SZ','STV Lachen','STV Tuggen','STV Wägital','TV Buttikon-Schübelbach','Leichtathletik Arth','LAR Tägerwilen-Kreuzlingen','TSV Guntershausen','KTV Frauenfeld','STV Berg','LAR Bischofszell','STV Güttingen','LC Bottighofen','STV Neukirch-Egnach','LC Frauenfeld','TV Eschlikon','Amriswil-Athletics','GAB Bellinzona','SA Bellinzona','Atletica Tenero 90','Vis Nova Agarone','SAG Gordola','VIRTUS Locarno','US Ascona atletica','SFG Biasca','SFG Airolo','ASSPO Riva San Vitale','Atletica Mendrisiotto','SFG Chiasso','SAV Vacallo','SVAM Muggio','SFG Mendrisio','VIGOR Ligornetto','SAM Massagno','SAL Lugano','USC Capriaschese-Atletica','GAD Dongio','Unitas Malcantone','FG Malcantone','AS Monteceneri',"Runner's Club Bellinzona",
      'Stade Lausanne Athlétisme','Lausanne-Sports Athlétisme','CM Cour Lausanne','FSG Saint-Cierges','FSG Epalinges','COVA Nyon','US Yverdon','CA Broyard','FSG Avenches','CA Riviera','FSG Morges','Ecole nouvelle de la Suisse Romande','FSG La Sarraz','Running Team Prilly','Gym Rolle','Croc-Kil...Leysin','ATLET(Association Team Léman Espoirs Triathlon)','Société de gymnastique de Moudon','Société de Gymnastique de Saint-Prex','FSG Chexbres','FSG Penthalaz','ATHLE.ch','Amis-Gym Forel-Savigny','FSG Orbe-Ancienne','FSG Grandson','AthleTEAM Lutry','Club de Marche de Monthey','SG St-Maurice','SFG Collombey-Muraz','CABV Martigny','CS 13 Etoiles','SFG Conthey','CA Sion','CA Vétroz','ES Ayent Anzère','LLT Oberwallis','TV Naters','LV Visp','STV Gampel','CA Sierre DSG','T-R-T Athlétisme Monthey','CA Dents-du-Midi','Académie Trail Running Valais','Termen athletics','CC Running Saxon','TV Hausen a.A.','LAC TV Unterstrass','STV Wiedikon','LC Zürich','TV Altstetten-Zürich','SATUS Zürich-Oerlikon','LC Regensdorf','TV Egg','Adliswil Track Team','LC Turicum','TV Kloten LA','TV Dietlikon','LV Winterthur','TV NS Winterthur','TV Kilchberg','Leichtathletik-Club Dübendorf','LC Uster','TV Uster','TV Oerlikon','LV Zürcher Oberland','LAR TV Rüti','TV Hombrechtikon','LC Meilen','TV Thalwil','TV Horgen','TV Wädenswil','LV Albis','TV Maur','LA Wyland','TG Hütten','LGKE Küsnacht-Erlenbach','TV Otelfingen','LC Rafzerfeld','TV Dägerlen','SSC Athletics','Turnverein Wiesendangen','STV Höri','LC Furttal ZH-Nord','TV Richterswil',],
      form: {
        nwpId: this.event.id, // Id des Wettkampfes
        firstName: '', // Vorname
        lastName: '', // Nachname
        ageGroup: '', // Jahrgang
        satMemberNumber: '', // Swiss Athletics Lizenznummer
        sex: '', // Geschlecht
        addressLine1: '', // Adresse
        zip: '', // PLZ
        city: '', // Ort
        canton: '', // Kanton
        club: '', // Verein
        email: '', // E-Mail
        emailType: '', // E-Mail Typ
        language: '', // Sprache
        agbAccepted: false, // AGB & Teilnahmebedingungen wurden akzeptiert
        receivePartnerOffers: false, // Informationen über Partnerangebote sind erlaubt
      },
      selectFields: {
        ageGroup: [],
        sex: [],
        canton: [],
        emailType: [],
        language: []
      },
      formFeedback: {
        display: false,
        message: '',
        type: 'info',
      },
      feedback: {
        display: false,
        type: '',
        title: '',
        message: '',
        displayBtns: true,
      },
      customError: {
        agbAccepted: {
          display: false,
          message: ""
        }
      },
      displayRegisterForm: true,
      displayPageLoader: false
    };
  },
  props: {
    event: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  created() {
    this.getLanguage();
    this.getCantonsList();
    this.getEmailTypeList();
    this.getSex();
    this.calculateAgeGroups();
  },
  methods: {
    calculateAgeGroups() {
      var minAge = 0;
      var maxAge = 15; // Max. 15 Jahre ist vordefiniert
      var minYear = 0;
      var maxYear = 0;
      var currentYear = new Date().getFullYear();
      var youngestCategory = this.event.youngestCategory || false;
      
      // Parse min. Alter aus dem LIC, falls keine lokale Ausscheidung
      if (youngestCategory) {
        minAge = parseInt(youngestCategory.match(/\d+/).shift());
      }

      // Hebe min. Alter auf, wenn Jüngste-Kategorie nicht M10/W10 ist
      if (minAge != 10) {
        minAge = 0;
      }

      minYear = currentYear - minAge;
      maxYear = currentYear - maxAge;

      var ageGroup = [];
      for (let index = maxYear; index <= minYear; index++) {
        ageGroup.push(index);
      }

      this.selectFields.ageGroup = ageGroup.reverse();
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    mapLov(arr) {
      return arr.map((obj) => {
        var rObj = { value: "", text: "" };
        rObj.value = obj.lic;
        rObj.text = this.$t(obj.lic);
        return rObj;
      });
    },
    getCantonsList() {
      this.$store
        .dispatch("lov/getCantonList")
        .then((resp) => {
          this.selectFields.canton = this.mapLov(resp.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguage() {
      this.$store
        .dispatch("lov/getLanguage")
        .then((resp) => {
          this.selectFields.language = this.mapLov(resp.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getEmailTypeList() {
      this.$store
        .dispatch("lov/getEmailType")
        .then((resp) => {
          this.selectFields.emailType = this.mapLov(resp.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSex() {
      this.$store
        .dispatch("lov/getSex")
        .then((resp) => {
          this.selectFields.sex = this.mapLov(resp.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    backToForm() {
      this.resetFormFeedback();
      this.displayRegisterForm = true;
    },
    resetFormFeedback() {
      this.feedback.display = false;
      this.feedback.type = '';
      this.feedback.title = '';
      this.feedback.message = '';
      this.feedback.displayBtns = true;

      this.formFeedback.display = false;
      this.formFeedback.message = '';
      this.formFeedback.type = 'info';
    },
    resetAthleteNumber() {
      this.$emit('reset-einzelanmeldung')
    },
    registerAthlete() {
      this.displayPageLoader = true;

      // Prüfe ob Teilnahmebedingungen akzeptiert wurden (breche anmeldung ab, falls nicht)
      if (this.form.agbAccepted === false) {
        this.customError.agbAccepted.message = this.$t('event_anmeldung.error_terms_not_accepted');
        this.customError.agbAccepted.display = true;
        this.displayPageLoader = false;
        return;
      }

      // Sende formular daten an api
      this.$store
        .dispatch("wettkampf/setTeilnehmer", this.form)
        .then(() => {
          this.displayRegisterForm = false; // Hide Form on success

          this.feedback.type = 'success';
          this.feedback.title = this.$t('event_anmeldung.text_anmeldung_erfolgreich');
          this.feedback.message = this.$t('event_anmeldung.text_anmeldung_email_benachrichtigung');
          this.feedback.displayBtns = true;
          this.feedback.display = true;
        })
        .catch((err) => {
          var severity = '';
          var errorCode = '';
          var debugMessage = '';
          var userFriendlyMessage = '';
          var lic = '';

          try {
            severity = err.response.data.severity;
            errorCode = err.response.data.errorCode;
            debugMessage = err.response.data.debugMessage;
            userFriendlyMessage = err.response.data.userFriendlyMessage;
            lic = err.response.data.lic;
          } catch (error) {
            severity = '';
            errorCode = '';
            debugMessage = '';
            userFriendlyMessage = '';
            lic = '';
          }
          
          if (errorCode == 'NAMESDONTMATCH' && userFriendlyMessage) {
            this.formFeedback.message = `${this.$t('event_anmeldung.error_license_not_matching')} - ${userFriendlyMessage}.`;
          } else if (errorCode == 'YEAROFBIRTHDONTMATCH' && userFriendlyMessage) {
            this.formFeedback.message = `${this.$t('event_anmeldung.error_license_not_matching')} - ${userFriendlyMessage}.`;
          } else if (debugMessage.includes('satMemberNumber')) {
            this.formFeedback.message = `${this.$t('event_anmeldung.error_license_not_matching')} - ${this.$t('event_anmeldung.text_try_again_later')}`;
          } else {
            // Do nothing
          }

          if (this.formFeedback.message) {
            this.formFeedback.type = 'danger';
            this.formFeedback.display = true;
            this.displayPageLoader = false;
            return
          }

          this.displayRegisterForm = false;

          try {
            this.feedback.message = errorCode == 'KIDALREADYREGISTEREDEVENT' && userFriendlyMessage ? userFriendlyMessage : `${this.$t('event_anmeldung.error_something_went_wrong')} - ${this.$t('event_anmeldung.text_try_again_later')}`;
          } catch (error) {
            this.feedback.message = `${this.$t('event_anmeldung.error_something_went_wrong')} - ${this.$t('event_anmeldung.text_try_again_later')}`;
          }

          this.feedback.type = 'danger';
          this.feedback.title = this.$t('event_anmeldung.text_anmeldung_fehlgeschlagen');
          this.feedback.displayBtns = false;
          this.feedback.display = true;
        })
        .then(() => {
          this.displayPageLoader = false;
        });
    },
    clubSelected() {
      const searchTerm = this.form.club.toLowerCase();
      this.vereine = this.vereinListe.filter(vereine => vereine.toLowerCase().includes(searchTerm));
    },
  },
};
</script>

<style lang="scss" scoped>
#pageLoader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(239, 239, 239, 0.6);
}
</style>
